import React from 'react';
import I18n from 'utils/I18n';
import clsx from '@strava/ui/clsx';
import { ActionsCheckCircleOnXsmall } from '@strava/icons';
import { useCheckoutContext } from '../../../state/CheckoutContext';
import { getStyles as _getStyles } from '../../../utils/checkoutUtils.js';

import styles from './SubscriptionFeatures.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

const SubscriptionFeatures = () => {
  const { checkoutEntityState } = useCheckoutContext();
  const { experiments } = checkoutEntityState;
  const { shouldShowPromoOnTrial } = experiments;
  const getStyles = (style) =>
    _getStyles(styles, style, shouldShowPromoOnTrial);

  const features = [
    {
      description: I18n.t(`${I18nPrefix}.feature_route`)
    },
    {
      description: I18n.t(`${I18nPrefix}.feature_analysis`)
    },
    {
      description: I18n.t(`${I18nPrefix}.feature_segment`)
    },
    {
      description: I18n.t(`${I18nPrefix}.feature_trail`),
      badge: I18n.t(`${I18nPrefix}.feature_trail_badge`)
    }
  ];

  return (
    <ul className={styles.subscriptionFeatures}>
      {features.map((feature) => (
        <li className={clsx(getStyles('featureItem'))}>
          <div className={styles.featureItemIconContainer}>
            <ActionsCheckCircleOnXsmall />
          </div>
          <span>{feature.description}</span>
          {feature.badge && (
            <span className={clsx(getStyles('badge'))}>
              {feature.badge.toUpperCase()}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default SubscriptionFeatures;
